import { del, get, post, put } from "./http-provider";
import qs from "qs";
export const SERVICE_URLS = {
  login: "/api/auth/login",
  regsiter: "/api/auth/register",
  projectStatus: "/api/project?limit=6&page=",
  singleProject: "/api/project/",
  nextProject: "/api/project/create-next-report/",
  createMaterialReport: "/api/project/create-material-report/",
  billingAddress: "/api/user/otp/",
  category: "/api/category/service/",
  service: "/api/service",
  checkProjectName: "/api/project/check-name",
  forgetPassword: "/api/user/otp",
  otpVerify: "/api/user/otp-verify",
  resetPassword: "/api/user/reset-password",
  updateUserProfile: "/api/user/update",
  updateProfileImg: "/api/upload/files",
  currentUser: "/api/user/profile?userId=",
  subCategories: `/api/category`,
  uploadPdf: `/api/upload/pdf`,
  createProject: `/api/project`,
  materialPriceingRange: `/api/material-price`,
  saveCostingReport: `/api/project/save-costing-report`,
};
const login = (data) => post(SERVICE_URLS.login, data);
const regsiter = (data) => post(SERVICE_URLS.regsiter, data);
const getSingleProject = (params) => get(SERVICE_URLS.singleProject + params);
const getprojectStatus = (params) => get(SERVICE_URLS.projectStatus + params);
const nextProject = (params, data) =>
  post(SERVICE_URLS.nextProject + params, data);
const createMaterialReport = (params) =>
  put(SERVICE_URLS.createMaterialReport + params);
const billingAddress = (data) => post(SERVICE_URLS.billingAddress, data);
const getcategory = (serviceId, page, limit) => get(SERVICE_URLS.category + `${serviceId}?page=${page}&limit=${limit}`); 
const getservice = (page, limit) => get(SERVICE_URLS.service + `?page=${page}&limit=${limit}`);
const checkProjectName = (data) => post(SERVICE_URLS.checkProjectName, data);
const forgetPassword = (data) => post(SERVICE_URLS.forgetPassword, data);
const otpVerify = (data) => put(SERVICE_URLS.otpVerify, data);
const resetPassword = (data) => put(SERVICE_URLS.resetPassword, data);
const updateUserProfile = (data) => put(SERVICE_URLS.updateUserProfile, data);
const updateProfileImg = (data) =>
  post(SERVICE_URLS.updateProfileImg, data, true);
const getCurrentUser = (params) => get(SERVICE_URLS.currentUser + params);
const getSubCategories = (params) => {
  const query = qs.stringify(params);
  return get(`${SERVICE_URLS.subCategories}?${query}`);
};
const uploadPdf = (data) => post(SERVICE_URLS.uploadPdf, data, true);
const createProject = (data) => post(SERVICE_URLS.createProject, data);
const materialPriceingRange = (params = {}) => {
  const query = qs.stringify(params, { addQueryPrefix: true });
  return get(SERVICE_URLS.materialPriceingRange + query);
};
const saveCostingReport = (projectID, data) =>
  put(`${SERVICE_URLS.saveCostingReport}/${projectID}`, data);

const apiServices = {
  regsiter,
  login,
  getprojectStatus,
  getSingleProject,
  nextProject,
  createMaterialReport,
  billingAddress,
  getcategory,
  getservice,
  checkProjectName,
  forgetPassword,
  otpVerify,
  resetPassword,
  updateUserProfile,
  updateProfileImg,
  getCurrentUser,
  getSubCategories,
  uploadPdf,
  createProject,
  materialPriceingRange,
  saveCostingReport,
};

export default apiServices;
